import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getList } from "./LogAPI";

const initialState = {
    prjId:'',
    prjName:'',
    logsData: {},
    apiStatus: 'idle'
}

export const getLogsDataAsync = createAsyncThunk(
    'log/getLogsDataAsync',
    async (input, thunkAPI) => {
        //const response = await login(input);
        let res;
        try {
            res = getList(input);
        } catch (e) {
            thunkAPI.rejectWithValue({ errorMessage: 'Fetch error' });
            return;
        }

        //return response.data;
        //return JSON.parse(res.json());
        return res;
    }
);

const logListSlice = createSlice({
    name: "log",
    initialState,
    reducers: {
    },

    extraReducers: (builder) => {
        builder
            .addCase(getLogsDataAsync.pending, (state) => {
                state.apiStatus = 'loading';
            })
            .addCase(getLogsDataAsync.fulfilled, (state, action) => {
                state.apiStatus = 'idle';
                state.LogsData = action.payload;
            })
            .addCase(getLogsDataAsync.rejected, (state, action) => {
                state.apiStatus = 'idle';
                state.logsData = {};
            });
    },
});


export const selectLogsData = (state) => state.log.logsData;

export default logListSlice;